import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { searchIconSVG } from 'src/app/constants/svgs/search-icon';
import { CallAPIService } from 'src/app/services/call-api.service';
import { Router } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { APIConfigService } from 'src/app/services/api-config.service';
import { PageAPIResp } from 'src/app/models/api-config.model';
import { cacheKeys } from 'src/app/constants/cache-keys';
import { ShareDataService } from 'src/app/services/share-data.service';

@Component({
  selector: 'app-global-search-input',
  templateUrl: './global-search-input.component.html',
  styleUrls: ['./global-search-input.component.scss'],
})
export class GlobalSearchInputComponent implements OnInit {
  @Input() width!: any;
  @Output() searchByKey = new EventEmitter<any>();
  @Output() searchKeyLength = new EventEmitter<any>();
  @Output() searchByEnter = new EventEmitter<any>();
  @Output() focusEvent = new EventEmitter<any>();
  searchIconSVG = searchIconSVG;
  public suggesion = false;
  public search = new FormControl();
  enteredWord: string = '';
  public keySearchResultRes: any = [];
  public isSuggestedResult: boolean = false;
  public trendingList: any[] = [];
  public recentSearch: any = [];
  public charCode:any
  allAPIsResp: PageAPIResp = {};
  public trendingServiceCacheKey = cacheKeys.trendingSrvs;
  showSearch: boolean = false;
  @Output() closeSearch = new EventEmitter<boolean>();
  suggestedResult: any;
  @Output() keyupSearch = new EventEmitter<any>();


  constructor(
    private callApiService: CallAPIService,
    private router: Router,
    private storeService: StoreService,
    private apiConfigService: APIConfigService,
    public shareDataService: ShareDataService
  ) {}

  ngOnInit(): void {
    this.recentSearchResult();
  }
  
  enteredSearchResult(enteredKey:any) {
    if(enteredKey?.length >= 3){
      this.enteredWord = enteredKey;
      if (enteredKey === '') {
        this.showSearch = false;
        return;
      }
      const originalEnteredKey = enteredKey;
      enteredKey = enteredKey.toLowerCase();
      this.setRecentSearch(enteredKey);
      this.showSearch = false;
      this.shareDataService.setValueByKey('search-text', enteredKey);
      this.shareDataService.isSearchKey.next({key: originalEnteredKey});
      localStorage.setItem('searchedText', JSON.stringify({key: originalEnteredKey}));
      this.router.navigateByUrl('/search/search-result');
    }
  }
  
  setRecentSearch(enteredKey:any) {
    const recentSearch = localStorage.getItem('recentSearch');
    if (recentSearch) {
      const _recentSearch = JSON.parse(recentSearch);
      if(enteredKey !== '' && enteredKey !== ' ' ){
        if (_recentSearch.length > 4) {
          let searchVal = _recentSearch;
          searchVal = searchVal.slice(_recentSearch.length - 3, _recentSearch.length);
          searchVal.unshift({ alises: enteredKey });
          localStorage.setItem('recentSearch', JSON.stringify(searchVal));
        } else if (_recentSearch.length === 4) {
          let searchVal = _recentSearch;
          searchVal.pop();
          searchVal.unshift({ alises: enteredKey });
          localStorage.setItem('recentSearch', JSON.stringify(searchVal));
        } else {
          let searchVal = JSON.parse(localStorage.getItem('recentSearch')!);
          searchVal.push({ alises: enteredKey });
          localStorage.setItem('recentSearch', JSON.stringify(searchVal));
        }
      }
    } else {
      if(enteredKey !== '' && enteredKey !== ' '){
        const tempVal = [{ alises: enteredKey }];
        localStorage.setItem('recentSearch', JSON.stringify(tempVal));
      }
      
    }
  }

  searchValChangeSubscription() {
    this.search.valueChanges
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((key) => {
        this.searchKeyLength.emit(key.length);
        if (key.length) {
            if(this.charCode != 13) {
            this.suggesion = true;
            this.getKeySearchResult(key);
          } else {
            this.suggesion = false;
            this.keySearchResultRes = [];
          }
          }

      });
  }

  getKeySearchResult(searchKeywords: any) {
    this.isSuggestedResult = false;
    this.callApiService.appKeySearch(searchKeywords).subscribe((res: any) => {
      this.keySearchResultRes = res?.response?.docs;
      this.searchByKey.emit(res.response.docs);
      if (this.keySearchResultRes?.length) {
        this.isSuggestedResult = true;
      } else this.isSuggestedResult = false;
    });
  }

  closeSuggestion() {
    this.suggesion = false;
    this.search.reset();
    this.searchKeyLength.emit(0);
  }

  public validateNumericInput(event:any) {
    this.charCode = event.which ? event.which : event.keyCode;
    if(this.charCode == 13) {
      this.enterSearchKeywords(event);
    }
  }

  public enterSearchKeywords(enteredKey?: any) {
    
    this.suggesion = false;
    let targettedVal = enteredKey.target.value;
    targettedVal = targettedVal && targettedVal.toLowerCase();
    this.getSearchResult(targettedVal);
    this.recentSearchResult(targettedVal);
    this.storeService.filteredResult = true;
  }

  getSearchResult(enteredKey?: any) {
    this.suggesion = false;
    this.callApiService
      .appLangSearch(enteredKey, '*', '*', false)
      .subscribe((res: any) => {
        if (res.response.docs) {
          this.searchByEnter.emit(res.response.docs);
        }
      });
  }

  navigateToDept(searchInput: any) {
    this.recentSearchResult(searchInput);
    this.getSearchResult(searchInput);
    this.suggesion = false;
    this.storeService.filteredResult = true;
  }

  recentSearchResult(searchInput?: any) {
    let currentLocalStorageList = localStorage.getItem('recentSearch')
      ? JSON.parse(localStorage.getItem('recentSearch') as any)
      : [];
    searchInput && currentLocalStorageList.push(searchInput);
    currentLocalStorageList = Array.from(new Set(currentLocalStorageList));
    localStorage.setItem(
      'recentSearch',
      JSON.stringify(currentLocalStorageList)
    );
    if (currentLocalStorageList.length > 5) {
      currentLocalStorageList.shift();
    }
    localStorage.setItem(
      'recentSearch',
      JSON.stringify(currentLocalStorageList)
    );
    this.recentSearch = currentLocalStorageList;
  }

  onKeyup(event: KeyboardEvent): void {
    this.keyupSearch.emit(event);
  }
}
